import { createFileRoute } from '@tanstack/react-router'
import { OverlayPage } from '@/features/overlay/OverlayPage'

export const Route = createFileRoute('/_authenticated/overlay')({
  component: OverlayPage,
})
